<template>
  <div class="graph-data-dailog container-block col-block">
    <div class="title-container row-block default-shadow">
      <div class="row-block" :style="{ width: '35px' }"></div>
      <div
        class="title"
        v-html="'零售價格資料'"
      ></div>
      <div class="row-block close-button" :style="{ width: '35px' }">
        <img :src="require('../../assets/images/analysis-close-icon.svg')" @click="e => $emit('changeModal')">
      </div>
    </div>
    <div class="graph-data-container col-block" :style="{ flex: 1, height: 0 }">
      <div v-if="onSearch" class="mask center-block">
        <!-- <img :src="require('../../assets/images/loading.gif')"> -->
        <img :src="require('../../assets/images/upload.svg')" alt="">
      </div>
      <div class="datas-container col-block">
        <div class="table-container col-block" :style="{ height: '50px' }">
          <div class="thead default-shadow">
            <div class="tr row-block">
              <div
                v-for="(option, index) in tableOptions"
                :key="index"
                class="th row-block"
                :class="option.class"
                :style="option.width ? { width: option.width } : { flex: 1 }"
                @click="e => option.sort !== false && tableSortBy(option.value)"
              >
                <span>{{ option.title }}</span>
                <div :style="{ width: '5px' }"></div>
                <i v-if="option.sort !== false" :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.value)] || '')]" aria-hidden="true"></i>
                <div :style="{ flex: 1 }"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container col-block sub-shadow" :style="{ flex: 1 }">
          <div class="tbody" :style="{ flex: 1 }">
            <div>
              <div class="tr row-block" :class="{ active: currentData && currentData.id === data.id }" v-for="(data, cindex) in datas" :key="cindex" @click="e => searchData(data)">
                <div class="container-block row-block">
                  <div
                    v-for="(option, index) in tableOptions"
                    :key="index"
                    class="td row-block"
                    :class="option.class"
                    :style="option.width ? { width: option.width } : { flex: 1 }"
                  >
                    <span :title="(option.display || (x => x))(data[option.value], cindex)" :style="(option.style || (() => {}))(data[option.value])">{{ (option.display || (x => x))(data[option.value], cindex) || '--' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page-container center-block">
          <pageButtons
            v-if="pageData.total"
            :default="pageData.selectedPage"
            :display="pageData.display"
            :total="pageData.total"
            :buttonRange="pageData.buttonRange"
            @selectPage="page => { pageData.selectedPage = page; searchDatas() }"
          ></pageButtons>
        </div>
      </div>
      <div class="data-container" :style="{ flex: 1, height: 0 }">
        <div class="data-field col-block" v-if="currentData">
          <div class="data-row row-block" v-for="(datas, oindex) in dataOptions" :key="oindex">
            <div class="data-block row-block" v-for="(data, dindex) in datas" :key="dindex" :style="{ flex: data.flex || 1 }">
              <div v-if="data.title" class="data-title row-block" :style="{ width: '70px' }">
                <span v-for="(c, cindex) in data.title" :key="cindex">{{ c }}</span>
              </div>
              <div class="data-title" :style="{ opacity: (data.type || (() => ''))(currentData) === 'image' ? 0 : 1 }">：</div>
              <template v-if="(data.type || (() => ''))(currentData) === 'image'">
                <div class="data-image col-block">
                  <div class="image-block center-block" v-for="(file, findex) in (data.value || (() => ''))(currentData) || []" :key="findex">
                    <img :src="file.url" alt="">
                  </div>
                </div>
                <div :style="{ flex: 1 }"></div>
              </template>
              <template v-else>
                <div class="data-content-container row-block">
                  <div v-if="data.title" class="data-content" v-html="(data.value || (() => ''))(currentData) || '--'"></div>
                  <template v-if="data.description">
                    <div :style="{ width: '5px' }"></div>
                    <borCor
                      :blockStyle="{
                        padding: '6px 8px'
                      }"
                    >
                      <div slot="trigger">
                        <div class="img-container center-block">
                          <img :src="require('../../assets/images/graph-data-info-icon.svg')" alt="">
                        </div>
                      </div>
                      <div class="content" slot="content">
                        <div class="text">{{ data.description }}</div>
                      </div>
                    </borCor>
                  </template>
                </div>
                <div :style="{ width: '20px' }"></div>
                <div :style="{ flex: 1 }"></div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProductPriceGraphDatas, getProductPriceGraphData } from '../../api'
import pageButtons from '../../components/tool/pageButtons'
import borCor from '../../components/tool/borCor'
import routeLoading from '../../mixins/routeLoading'
import toastMethods from '../../mixins/toastMethods'
import userPermission from '../../mixins/userPermission'
import { dateFormat } from '../../constants/global/util'

export default {
  components: {
    pageButtons,
    borCor
  },
  mixins: [
    routeLoading,
    toastMethods,
    userPermission
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      datas: [],
      currentData: null,
      onSearch: false,
      pageData: {
        selectedPage: 1,
        display: 5,
        total: null,
        buttonRange: 7
      },
      sort: {
        value: [],
        order: []
      }
    }
  },
  computed: {
    // static
    tableOptions () {
      return [
        {
          title: '拍攝日期',
          value: 'date',
          width: '120px',
          display: value => value ? dateFormat(new Date(value), 'yyyy/MM/dd') : ''
        },
        {
          title: '產地(國家)',
          value: 'country',
          width: '150px',
          display: value => (this.param.options.country.find(option => option.value === value) || {}).title || '無'
        },
        {
          title: '包裝方式',
          value: 'packing_method',
          width: '100px',
          display: value => (this.param.options.packingMethod.find(option => option.value === value) || {}).title
        },
        {
          title: '價格',
          value: 'price',
          width: '80px'
        },
        {
          title: '計價貨幣',
          value: 'currency_name',
          width: '100px'
        },
        {
          title: '市場所在國家',
          value: 'market_country',
          width: '150px',
          display: value => (this.param.options.country.find(option => option.value === value) || {}).title
        },
        {
          title: '市場類型',
          value: 'market_kind',
          display: value => (this.param.options.marketKind.find(option => option.value === value) || {}).title
        }
      ]
    },
    dataOptions () {
      return [
        [
          { title: '拍攝日期', value: data => data.date ? dateFormat(new Date(data.date), 'yyyy/MM/dd') : '' },
          { title: '作物(產品)', value: data => data.crop_name },
          { title: '產地', value: data => (this.param.options.country.find(option => option.value === data.country) || {}).title || '無' }
        ],
        [
          { title: '包裝方式', value: data => (this.param.options.packingMethod.find(option => option.value === data.packing_method) || {}).title },
          { title: '品名', value: data => data.product_name, flex: 2 }
        ],
        [
          { title: '價格', value: data => data.price + ' ' + data.currency_name + '<br>' + '(1 ' + data.currency_name + ' = ' + data.exchange_rate + ' 美元)', description: '此為上傳者提供之匯率資訊，並非金融機構之即期匯率。' },
          { title: '計價量', value: data => data.quantity + ' ' + (this.param.options.quantity.find(option => option.value === data.quantity_unit) || { title: '--' }).title + ' (' + (this.param.options.quantity.find(option => option.value === data.quantity_unit) || { type: '--' }).type + '計價)', flex: 2 }
        ],
        [
          { title: '市場類型', value: data => (this.param.options.marketKind.find(option => option.value === data.market_kind) || {}).title },
          { title: '市場名稱', value: data => data.market_name },
          { title: '市場所在國', value: data => (this.param.options.country.find(option => option.value === data.market_country) || {}).title }
        ],
        ...this.rolePermission(['advance', 'admin']) ? [
          [
            { title: '照片', value: data => data.photos.length ? data.photos : '', type: data => data.photos.length ? 'image' : '' }
          ]
        ] : []
      ]
    }
  },
  methods: {
    async fetchData () {
      await this.fetchProductPriceGraphDatas()
    },
    async fetchProductPriceGraphDatas () {
      try {
        let config = this.$ls.get('userInfo')
        let ids = this.param.ids
        let data = {}
        this.pageData.selectedPage && (data.page = this.pageData.selectedPage)
        this.pageData.display && (data.item_per_page = this.pageData.display)
        this.sort.value[0] && (data.order_by = this.sort.value[0])
        this.sort.order[0] && (data.order_method = this.sort.order[0].replace(/^-/, ''))
        let response = await getProductPriceGraphDatas(ids, data, config)
        let datas = response.data.data.elements
        this.pageData.total = response.data.data.items_count
        this.datas = datas
      } catch (error) {
        throw error
      }
    },
    async fetchProductPriceGraphData (data) {
      try {
        let config = this.$ls.get('userInfo')
        let id = data.id
        let response = await getProductPriceGraphData(id, config)
        let currentData = response.data.data
        this.currentData = currentData
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
        setTimeout(() => window.location.reload(), 500)
      }
    },
    async afterSetData () {
      if (this.param.defaultID) {
        await this.fetchProductPriceGraphData({ id: this.param.defaultID })
      }
    },
    async searchDatas () {
      this.onSearch = true
      await this.fetchData()
      this.onSearch = false
    },
    async searchData (data) {
      this.onSearch = true
      await this.fetchProductPriceGraphData(data)
      this.onSearch = false
    },
    tableSortBy (value) {
      let position = this.sort.value.indexOf(value)
      if (position === 0) {
        let order =
          this.sort.order[position] === '-asc' ? '-desc' : '-asc'
        this.sort.order.splice(position, 1)
        this.sort.order.unshift(order)
      } else {
        let order =
          position !== -1
            ? this.sort.order[position] === '-asc' ? '-desc' : '-asc'
            : undefined
        position = position !== -1 ? position : 0
        this.sort.value.splice(position, 1)
        this.sort.order.splice(position, 1)
        this.sort.value.unshift(value)
        this.sort.order.unshift(order || '-asc')
      }
      this.searchDatas()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/graphData.vue